import { z } from "zod";
import { SemanticQuerySchema } from "./query";
import type { InstalledFrom } from "./dashboard";
import { VisualizationSchema } from "./viz";

/**
 * A portable widget. Deliberately contains NO org, location, or user-scope data:
 * scope always comes from whoever is viewing it. This is what makes a future
 * cross-customer widget marketplace possible without a rewrite.
 */
export const WidgetDefinitionSchema = z.object({
  title: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  query: SemanticQuerySchema,
  visualization: VisualizationSchema,
});
export type WidgetDefinition = z.infer<typeof WidgetDefinitionSchema>;
export type WidgetDefinitionInput = z.input<typeof WidgetDefinitionSchema>;

export interface Widget {
  id: string;
  version: number;
  ownerId: string;
  definition: WidgetDefinition;
  createdAt: string;
  updatedAt: string;
  /** Present when it was installed from the marketplace (shown to its owner only). */
  installedFrom?: InstalledFrom;
}
